import * as React from "react";
const SvgMinus = props => <svg width={16} height={16} viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}><path d="M2 8H14" stroke="#797A7B" strokeLinejoin="round" /></svg>;
export default SvgMinus;